import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StickyElem } from '../../StickyElem'

const getCssDisplay = ({ minScreenSize, theme }) =>
  minScreenSize && theme.flyQueries[minScreenSize]
    ? `
      display: none;
      ${theme.flyQueries[minScreenSize]} {
        display: block;
      }
    `
    : 'display: block;'

const StyledAd = styled.div`
  margin-bottom: ${props => props.marginBottom}px;
  margin-left: auto;
  margin-right: auto;
  ${props => getCssDisplay(props)}
`

const StyledStickyContainer = styled(StickyElem)`
  ${props => getCssDisplay(props)}
`

const StandardAd = ({
  listingsLastUpdateTime,
  minScreenSize,
  isSticky,
  className,
  adId,
  marginBottom,
}) => (
  <StyledStickyContainer
    listingsLastUpdateTime={listingsLastUpdateTime}
    minScreenSize={minScreenSize}
    disableStickiness={!isSticky}
  >
    <StyledAd
      className={className}
      id={adId}
      minScreenSize={minScreenSize}
      marginBottom={marginBottom}
    />
  </StyledStickyContainer>
)

StandardAd.propTypes = {
  listingsLastUpdateTime: PropTypes.number,
  minScreenSize: PropTypes.string,
  isSticky: PropTypes.bool,
  className: PropTypes.string,
  adId: PropTypes.string,
  marginBottom: PropTypes.number,
}

export { StandardAd }
